<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="group_permission" />

    <GroupPermission
      :roles="filteredRoles"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      :loading="loading"
      @update:search-query="searchQuery = $event"
      @delete="deleteRole"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import GroupPermission from "../../components/Settings/GroupPermission/GroupPermission.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useRolePermission } from "../../composables/useRolePermission";

const {
  searchQuery,
  loading,
  filteredRoles,
  paginationConfig,
  fetchRoles,
  deleteRole,
} = useRolePermission();

onMounted(fetchRoles);
</script>
